{
  "slug": "how-can-i-find-out-my-iq",
  "title": "如何找出我的智商?",
  "description": "比较在线智商测试和监督下的专业评估,并学习如何获得和解释可信的认知分数。",
  "summary": "找出智商的正确方法取决于测试目的。 一个精心的在线测试可以提供一个指示性的估计,而临床、教育或资格决定需要一个合适的监督评估。",
  "category": "智商必修",
  "sections": [
    {
      "heading": "首先说明您想要得分的原因",
      "paragraphs": [
        "好奇心、实践、教育规划、临床评估和会员资格是不同的目标。 非正式的在线估计可能会回答好奇心问题,但不能替代受保护的专业工具。",
        "如果结果可能影响治疗, 住宿, 学校, 就业, 或正式申请, 问合格的心理学家或相关组织,它接受的测试和文件."
      ]
    },
    {
      "heading": "在线测试中要注意什么",
      "paragraphs": [
        "负责任的在线测试应该解释它采集了什么样本、需要多长时间、如何产生比较分数以及它无法确定什么样本，应该保护个人数据，避免声称诊断或保证准确性。",
        "请在休息后进行评估,使用安静的环境,遵循时间规则,避免外界帮助。 重复相同的项目可能会产生练习效果,因此后来的结果并不一定是更好的估计。"
      ]
    },
    {
      "heading": "专业测试的附加值",
      "paragraphs": [
        "专业评估使用标准化的管理、安全的材料、适当的年龄规范、多个子测试和行为观察,结果报告可能包括指数分数、置信区间和有意义差异的解释。",
        "询问仪器名称和版本、规范组、得分类型、置信区间和限值。 保留原始报告,以备日后需要合格结果的证明。"
      ]
    }
  ],
  "faqs": [
    {
      "question": "免费的在线测试能告诉我我的智商?",
      "answer": "如果设计得当,它可以提供一个指示性估计,但它不能确定一个准确、永久或临床分数。"
    },
    {
      "question": "谁可以进行官方智商测试?",
      "answer": "标准化临床检测通常由合格的专业人员进行,并由他们进行解释。"
    }
  ],
  "related": ["is-an-online-iq-test-accurate", "how-is-iq-measured", "free-online-iq-test-guide"],
  "sources": [
    {
      "label": "心理学词典 — 智力测试",
      "url": "https://dictionary.apa.org/intelligence-test"
    },
    {
      "label": "皮尔逊-西非信息系统5 样本得分报告",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    },
    {
      "label": "Mensa国际 — 让你的智商测试",
      "url": "https://www.mensa.org/getting-your-iq-tested-faqs/"
    }
  ]
}
